/**
 * ProLayout `menuHeaderRender`：侧栏顶部一行（Logo + 标题 + 展开/收起），替代 Pro 默认 logo 区布局。
 * 收起态与悬停逻辑见 `global.less`（`.video-ui-sider-*`）。
 */
import type { SiderMenuProps } from '@ant-design/pro-layout/es/components/SiderMenu/SiderMenu';
import React from 'react';

type MenuHeaderProps = SiderMenuProps & {
  onCollapse?: (collapsed: boolean) => void;
};

/**
 * Logo + 标题在左，展开/收起在右；侧栏自带的底部收起按钮已通过 `collapsedButtonRender={false}` 关闭。
 */
export function createSiderMenuHeaderRender() {
  return (
    logo: React.ReactNode,
    title: React.ReactNode | null,
    props?: MenuHeaderProps,
  ): React.ReactNode => {
    if (!props) {
      return null;
    }
    if (props.isMobile) {
      return (
        <div className="video-ui-sider-header-inner video-ui-sider-header-inner--mobile">
          {logo}
          {title}
        </div>
      );
    }

    const { collapsed, onCollapse } = props;
    const toggle = (e: React.MouseEvent) => {
      e.preventDefault();
      e.stopPropagation();
      onCollapse?.(!collapsed);
    };

    return (
      <div
        className={
          collapsed
            ? 'video-ui-sider-header-inner video-ui-sider-header-inner--collapsed'
            : 'video-ui-sider-header-inner'
        }
      >
        <div className="video-ui-sider-brand">
          {logo}
          {/* title 为 Pro 生成的 <h1>，勿再包一层 span，否则 h1 会吃浏览器默认大字 */}
          {title}
        </div>
        <button
          type="button"
          className="video-ui-sider-collapse-btn"
          aria-label={collapsed ? '展开菜单' : '收起菜单'}
          aria-expanded={!collapsed}
          onClick={toggle}
        >
          <span
            className="video-ui-sider-collapse-btn__icon"
            style={{
              transform: collapsed ? 'scaleX(-1)' : undefined,
            }}
          >
            <i className="iconfont icon-panel-left" aria-hidden />
          </span>
        </button>
      </div>
    );
  };
}
